import {useQuery} from "react-query";
import axios from "axios";
import {apiBase} from "./shared";
import { BibleVerseResponse } from "../models";

async function bibleSearch(searchText: string, bookFilter?: string | null) {
  const text = encodeURI(searchText);
  const bookFilterText = bookFilter != null ? `&bookFilter=${bookFilter}` : '';
  const { data } = await axios.get<BibleVerseResponse>(`${apiBase}BibleVerses?version=kjv&searchText=${text}&highlighting=true&limit=1000${bookFilterText}`);
  return data;
}

export function useBibleSearch(searchText: string, bookFilter?: string | null) {
  return useQuery(['bibleSearch', searchText, bookFilter], () => bibleSearch(searchText, bookFilter), {
    enabled: !!searchText || searchText.length > 2,
    refetchInterval: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
